module.exports = __webpack_public_path__ + "img/img-4.6914b5d2.png";